let cleanupCurrent = () => {};

export function initializePageJump() {
  cleanupCurrent();

  const jump = document.querySelector("[data-page-jump]");
  const root = document.documentElement;
  root.classList.toggle("has-page-jump", Boolean(jump));

  if (!jump) {
    cleanupCurrent = () => {};
    return;
  }

  const links = [...jump.querySelectorAll("[data-jump-link]")]
    .map((link) => ({
      link,
      target: document.getElementById(link.getAttribute("href")?.slice(1)),
    }))
    .filter(({ target }) => target);

  let frame = 0;

  function update() {
    frame = 0;

    const header = document.querySelector(".site-header");
    const headerHeight = Math.max(
      0,
      Math.round(header?.getBoundingClientRect().bottom ?? 0),
    );
    const visible =
      window.scrollY > 96 &&
      !document.body.classList.contains("mobile-menu-open");

    jump.classList.toggle("is-visible", visible);
    jump.setAttribute("aria-hidden", String(!visible));

    const stackHeight = headerHeight + (visible ? jump.offsetHeight : 0);
    root.style.setProperty("--live-header-height", `${headerHeight}px`);
    root.style.setProperty("--app-header-stack-height", `${stackHeight}px`);

    const active = links
      .filter(
        ({ target }) => target.getBoundingClientRect().top <= stackHeight + 32,
      )
      .at(-1)?.link;

    links.forEach(({ link }) => {
      if (link === active) link.setAttribute("aria-current", "location");
      else link.removeAttribute("aria-current");
    });
  }

  function scheduleUpdate() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  const clickHandlers = links.map(({ link, target }) => {
    const handler = (event) => {
      event.preventDefault();
      target.scrollIntoView({
        behavior: matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "instant"
          : "smooth",
        block: "start",
      });
      scheduleUpdate();
    };
    link.addEventListener("click", handler);
    return { link, handler };
  });

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate, { passive: true });
  scheduleUpdate();

  cleanupCurrent = () => {
    window.removeEventListener("scroll", scheduleUpdate);
    window.removeEventListener("resize", scheduleUpdate);
    clickHandlers.forEach(({ link, handler }) =>
      link.removeEventListener("click", handler),
    );
    cancelAnimationFrame(frame);
    root.classList.remove("has-page-jump");
  };
}
